import styled from "@emotion/styled";
import colors from "styles/colors";
import { TABLET_QUERY_MAX_WIDTH } from "constants/vp-sizes";
import { CLEAN_FIRST_FOLD_MARGIN } from "constants/pricing-sizes";
import { MODAL_BACKGROUND } from "/constants/z-index";
import { BRAND_DARK_COLOR, GAINSBORO_COLOR_NAME } from "styles/color-consts";
export const StyledProductPriceAndFeatures = styled.div`
  .horizontal-line {
    display: block;
    width: 100%;
    border-bottom: 2px solid #c5c7d0;
    margin: 24px 0;
  }

  .signup-form-wrapper {
    input {
      width: 100% !important;
      min-width: 0px !important;
    }
  }

  &.card {
    min-width: 0;
    flex: 1 0 0;
    border-radius: 4px;
    border: 1px solid #d5d5d5;
    padding: 16px;
    box-shadow: none;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .icons {
      height: 45px;
      display: flex;
      .icon {
        flex-shrink: 0;
        border: solid 1px;
        border-radius: 8px;
        width: 42px;
        height: 42px;
        padding: 4px;
        margin-right: 8px;
        color: #292f4c;
        display: flex;
        justify-content: center;
        align-items: center;
        border-color: var(--product-color);
      }
    }

    .tier-title-container {
      height: 50px;
      align-self: stretch;
    }

    .tier-title {
      margin: 8px 0;
      font-size: 1.238rem;
      color: #333333;
      letter-spacing: -0.36px;
      display: flex;
      align-items: center;
      position: relative;
      max-width: calc(100% - 80px);
      .product-and-tier {
        & > div {
          float: left;
        }
      }

      .tier {
        font-weight: bold;
        margin-right: 4px;
      }

      .most-popular-badge-container {
        flex-grow: 1;
      }

      .most-popular-badge {
        font-weight: 700;
        font-size: 0.8125rem;
        line-height: 16px;
        border-radius: 4px;
        width: 66px;
        padding: 8px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        margin-left: 16px;
        z-index: 2;
        color: white;
        &::before {
          z-index: 1;
          content: "";
          position: absolute;
          transform: rotate(45deg);
          width: 14px;
          height: 14px;
          left: -7px;
          top: calc(50% - 7px);
          display: block;
        }
      }
      .most-popular-badge,
      .most-popular-badge::before {
        background-color: ${({ styleColor })=>styleColor};
      }
    }
    &.is-most-popular {
      box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.2);
      .cta-button .ladda-button-component .signup-button,
      .cta-button .ladda-button-component .cta-button {
        color: black;
      }
    }

    .contact {
      height: 140px;
      padding: 16px 0;
      & > div {
        font-weight: 600;
      }
    }

    .cta-button {
      width: ${({ isContactUsCard, isMobileOrTabletBrowser })=>isContactUsCard || !isMobileOrTabletBrowser ? "auto" : "100%"};
      &.try-cta-padding {
        padding-bottom: 64px;
      }
      padding: 0 0 16px 0;
      .ladda-button-component .signup-button,
      .ladda-button-component .cta-button {
        background-color: transparent;
        border: 1px solid black;
        color: black;
        letter-spacing: 0.4px;
        * {
          font-weight: bold;
        }
      }
      .ladda-button-component .signup-button:hover,
      .ladda-button-component .cta-button:hover {
        border-color: ${({ ctaHoverBorderColor })=>ctaHoverBorderColor};
        background-color: ${({ ctaHoverBackgroundColor })=>ctaHoverBackgroundColor};
        color: ${({ ctaHoverTextColor })=>ctaHoverTextColor};
        filter: none;
      }
    }

    .pricing-signup-purchase-now {
      display: flex;
      gap: 5px;
      margin-bottom: ${CLEAN_FIRST_FOLD_MARGIN};
      height: 20px;
    }

    .purchase-now-link {
      font-weight: bold;
      text-decoration-line: underline;
    }

    .description {
      font-size: 0.875rem;
      line-height: 24px;
      height: 70px;
      letter-spacing: -0.36px;
      color: #676879;
    }

    .feature {
      font-size: 0.844rem;
      margin-bottom: 24px;
      display: flex;
      align-self: stretch;
      align-items: center;
      justify-content: space-between;
      .icon {
        position: relative;
        margin-left: 6px;
        .tooltip {
          z-index: ${MODAL_BACKGROUND};
          display: none;
          opacity: 0;
          position: absolute;
          bottom: calc(100% + 16px);
          transform: translateX(-50%);
          transition: opacity 0.2s ease;
          width: 300px;
          .floating-tooltip {
            position: relative;
            white-space: normal;
            text-align: left;
          }
        }
        &:hover {
          .tooltip {
            display: block;
            opacity: 1;
            transform: translateX(-24.8%);
          }
        }
      }
      .name-and-label {
        display: flex;
        align-items: center;
        gap: 8px;
      }
    }
  }

  @media (max-width: ${TABLET_QUERY_MAX_WIDTH}) {
    .ladda-button-component {
      .cta-button {
        .signup-form {
          input {
            min-width: 240px;
          }
        }
      }
    }
  }
`;
export const StyledProductPriceAndFeaturesWrapper = styled.div`
  &.card-container {
    &.is-homepage-pricing {
      display: flex;
      flex-direction: column;
      margin-top: 30px;
      .most-popular {
        background: ${colors[BRAND_DARK_COLOR]};
        text-align: center;
        padding: 4px;
        border-radius: 16px 16px 0px 0px;
        .most-popular-span {
          color: white;
          text-align: center;
          font-size: 14px;
          font-style: normal;
          font-weight: 600;
          line-height: 24px;
        }
      }
      .card {
        border-radius: 16px;
        margin-top: 16px;
        padding: 20px;

        &.is-most-popular {
          border-color: var(--primary-color);
        }

        .tier-title {
          max-width: 100%;
          .coming-soon {
            padding: 1px 8px;
            margin-left: 8px;
            justify-content: center;
            align-items: center;
            border: 1px solid ${colors.asphalt};
            border-radius: 4px;
            font-size: 14px;
            line-height: 22px;
          }
        }

        .amount {
          font-family: Poppins;
          font-size: 48px;
          font-style: normal;
          font-weight: 700;
          letter-spacing: -1px;
          margin-right: 8px;
        }
        .price-tag {
          align-items: center;
          display: flex;
          font-size: 16px;
          font-family: Sofia Pro;
          font-weight: 400;
        }
        .cta-button {
          width: 100%;
          border: none;
          padding: 0 0 16px 0;

          .ladda-button-component .signup-button,
          .ladda-button-component .cta-button {
            background-color: var(--primary-color);
            color: white;
            letter-spacing: 0.4px;
            max-width: none;
            width: 100%;
            border: none;
            padding: 12px 12px;
            &:hover {
              background-color: var(--secondary-color);
            }
          }
          .ladda-button-component .contact-us-button {
            border-color: 9px solid black;
            border: 1px solid var(--secondary-color);
            background-color: transparent;
            color: var(--secondary-color);

            .ladda-label {
              font-weight: 400;
              font-size: 14px;
            }
            &:hover {
              background-color: var(--secondary-color);
              color: white;
            }
          }
          .signup-form {
            display: inherit;
            width: 100%;
          }
          .signup-button-wrapper {
            width: inherit;
          }
          .signup-text {
            font-weight: 400;
            font-size: 14px;
            gap: 10px;
          }
        }

        .description {
          height: 70px;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 22px;
          letter-spacing: normal;
          display: flex;
        }

        .info-icon {
          height: 12px;
          width: 12px;
        }
        &.is-most-popular {
          margin-top: 0px;
          padding-top: 5px;
          border-radius: 0px 0px 16px 16px;
          border-top: none;
          box-shadow: none;
        }

        .tier-include {
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 16px;
        }
        .tier-learn-more-button {
          height: 32px;
          display: block;
          align-self: center;
          margin-bottom: 14px;
        }
        .play-wrapper,
        .secondary-button-text {
          color: var(--secondary-color);
        }
        .feature {
          .icon {
            .tooltip {
              transform: translateX(-25.4%);
            }
          }
        }
      }
      .currency-sign {
        font-size: 48px;
        font-weight: 100;
      }
      .horizontal-line {
        width: 100%;
        border-bottom: 1px solid;
        border-color: ${colors[GAINSBORO_COLOR_NAME]};
      }
    }
  }
`;
